module.exports = __webpack_public_path__ + "img/UY.42119fd4.png";